<template>
  <div class="campos-integracao-dinamicos">
    <component
      :is="componentePara(campo.tipo)"
      v-for="campo in campos"
      :key="campo.chave"
      :id-campo="idDoCampo(campo.chave)"
      :campo="campo"
      :value="valor[campo.chave]"
      :erro="erros[campo.chave]"
      :disabled="disabled"
      @input="emitirCampo(campo.chave, $event)"
    />
  </div>
</template>

<script>
import CampoTexto from './CampoTexto.vue'
import CampoSelect from './CampoSelect.vue'
import CampoToggle from './CampoToggle.vue'

// Este componente é o responsável por decidir QUAL campo renderizar por tipo — os componentes de
// campo são de responsabilidade única (sem ifs de tipo dentro deles).
const COMPONENTE_POR_TIPO = {
  text: CampoTexto,
  password: CampoTexto,
  url: CampoTexto,
  select: CampoSelect,
  toggle: CampoToggle
}

export default {
  name: 'CamposIntegracaoDinamicos',
  components: { CampoTexto, CampoSelect, CampoToggle },
  props: {
    campos: { type: Array, default: () => [] },
    valor: { type: Object, default: () => ({}) },
    erros: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    componentePara (tipo) {
      return COMPONENTE_POR_TIPO[tipo] || CampoTexto
    },
    idDoCampo (chave) {
      return 'campo-' + String(chave).replace(/[^a-zA-Z0-9]/g, '-')
    },
    emitirCampo (campoChave, valor) {
      this.$emit('campo-input', { campoChave, valor })
    }
  }
}
</script>
